// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1SubEntrySchema = z.object({
  id: z.number().int().describe("Unique identifier for the sub-entry"),
  uid: z.coerce.string().describe("Unique string identifier for the sub-entry"),
  entry_id: z.number().int().describe("Parent entry ID"),
  from: z.coerce.string().describe("Start time in ISO 8601 format").nullish(),
  to: z.coerce.string().describe("End time in ISO 8601 format").nullish(),
  note: z.coerce.string().describe("Notes for this sub-entry").nullish(),
});
